var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66004 3.0399V4.0298H4.38004V3.0399C4.38004 2.4103 4.89043 1.8999 5.52004 1.8999C6.14964 1.8999 6.66004 2.4103 6.66004 3.0399ZM0.900391 6.0298C0.900391 4.93202 1.78484 4.04082 2.88004 4.0299V3.0399C2.88004 1.58187 4.06201 0.399902 5.52004 0.399902C6.97807 0.399902 8.16004 1.58187 8.16004 3.0399V4.02989C9.25556 4.04043 10.1404 4.93178 10.1404 6.0298V9.94979C10.1404 11.0544 9.24496 11.9498 8.14039 11.9498H2.90039C1.79582 11.9498 0.900391 11.0544 0.900391 9.94979V6.0298ZM6.70973 7.165C6.70973 7.62648 6.43908 8.02475 6.04785 8.20974V9.47497C6.04785 9.74835 5.82623 9.96997 5.55285 9.96997C5.27947 9.96997 5.05785 9.74835 5.05785 9.47497V8.20796C4.66865 8.0222 4.39973 7.62501 4.39973 7.165C4.39973 6.52711 4.91684 6.01 5.55473 6.01C6.19262 6.01 6.70973 6.52711 6.70973 7.165Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.6438d813.svg";
export { ForwardRef as ReactComponent };